export default __webpack_public_path__ + "static/media/Walmart Converge bg.60478eb9.png";